export class ApiError extends Error {
  constructor(public code: string, public status: number, message: string, public requestId?: string, public retryable = false) { super(message); this.name = "ApiError"; }
}
export function normalizeApiError(error: unknown): ApiError {
  if (error instanceof ApiError) return error;
  if (error instanceof DOMException && error.name === "AbortError") return new ApiError("request_timeout", 408, "The request timed out.", undefined, true);
  if (error instanceof TypeError) return new ApiError("network_error", 0, "The service could not be reached.", undefined, true);
  return new ApiError("unexpected_error", 500, "An unexpected error occurred.");
}
